import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import React, { useEffect } from 'react';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';
import styles from './styles.module.scss';

export const getWeskiPartnerId = () => {
  const locale = getLocale();
  switch (locale) {
    case ELocale.EN_US:
    case ELocale.EN_GB:
    case ELocale.CS_CZ:
    case ELocale.SK_SK:
      return '3e08';
    case ELocale.FR_FR:
      return 'yc8q';
    default:
      // for all other locales
      return 'p7s9';
  }
};

const IS_FR = getLocale() === ELocale.FR_FR;

const WeSkiWidget = ({ destinationId, withTopCopy }: { destinationId: string, withTopCopy?: boolean }) => {
  const { t } = useOTSTranslation('common');

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://widget.weski.com';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <BoxWithShadow>
      {withTopCopy
        && (
          <p className={styles.copyWrapper}>
            {t('resort.bookTrip.copy')}
          </p>
        )}
      <div
        id="weski-widget"
        data-destination-id={destinationId}
        data-locale={IS_FR ? 'fr' : undefined}
        data-partner={getWeskiPartnerId()}
      />
    </BoxWithShadow>
  );
};

export default WeSkiWidget;
